"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = require("../../Button");
var Icon_1 = require("../../Icon");
var StackView_1 = require("../../StackView");
var Text_1 = require("../../Text");
var View_1 = require("../../View");
var OptionRoot_1 = require("../OptionRoot");
function createNewItemActionRenderer(_a) {
    var action = _a.action;
    return function footerNewItemActionRenderer(_a) {
        var searchTerm = _a.searchTerm;
        return (react_1.default.createElement(OptionRoot_1.OptionRoot, null,
            react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.row, gap: StackView_1.STACK_GAP.s, align: StackView_1.STACK_ALIGN.center, distribution: StackView_1.STACK_DISTRIBUTION.lastFill },
                react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.row, align: StackView_1.STACK_ALIGN.center, distribution: StackView_1.STACK_DISTRIBUTION.start, gap: StackView_1.STACK_GAP.m },
                    react_1.default.createElement(View_1.View, { spaceVertical: View_1.INDENT.s, align: View_1.VIEW_ALIGN.center },
                        react_1.default.createElement(Text_1.Text, { view: Text_1.TEXT_VIEW.primary, truncate: true, weight: Text_1.TEXT_WEIGHT.bold }, searchTerm)),
                    react_1.default.createElement(View_1.View, { align: View_1.VIEW_ALIGN.center, collapsable: false },
                        react_1.default.createElement(StackView_1.StackView, { align: StackView_1.STACK_ALIGN.center, gap: StackView_1.STACK_GAP.s },
                            action.icon && react_1.default.createElement(Icon_1.Icon, { src: action.icon }),
                            react_1.default.createElement(Button_1.Button, { ui: Button_1.BUTTON_VIEW.text, onClick: action.onClick }, action.text)))))));
    };
}
exports.createNewItemActionRenderer = createNewItemActionRenderer;
//# sourceMappingURL=footerActionRenderer.js.map